import React from 'react';

import TableCell from '@mui/material/TableCell';
import Grid from '@mui/material/Grid';

export default function GroupCell({ groups }) {
  return (
    <TableCell align="left">
      {groups && groups.length > 0 && (
        <Grid container direction="row" spacing={1}>
          <Grid item>{groups[0].name}</Grid>
          {groups && groups.length > 1 && (
            <Grid item style={{ fontWeight: 'bold' }}>
              +{groups.length - 1} more
            </Grid>
          )}
        </Grid>
      )}
      {groups && groups.length === 0 && 'N/A'}
    </TableCell>
  );
}
